import { LabelRegular, TextMedium } from "@hm/fundamental"

interface ChangeRowProps {
	label: string
	from: string
	to: string
}

export const ChangeRow: React.FC<ChangeRowProps> = ({ label, from, to }) => (
	<div className="flex flex-col">
		<LabelRegular className="text-foreground_faded">{label}</LabelRegular>
		<TextMedium className="text-foreground">
			{from} → {to}
		</TextMedium>
	</div>
)
